module.exports = __webpack_public_path__ + "static/img/banner9.acb4ce27.png";